import { coloredIcons } from '@aibees/shared/constants/icons';
import { IconWithColor } from '@aibees/shared/definition/metadata';
import { TransferListItem, TransferListType } from '../types';

function getIconMetadata(type: TransferListType) {
  if (type === TransferListType.Company) return coloredIcons.company;
  else if (type === TransferListType.People) return coloredIcons.people;
  else if (type === TransferListType.Departments)
    return coloredIcons.department;
  return coloredIcons.company;
}

export function useGroupedItemsByType(items?: TransferListItem[]) {
  return items?.reduce(
    (acc, item) => {
      if (!acc[item.type]) {
        acc[item.type] = {
          items: [],
          icon: getIconMetadata(item.type),
        };
      }
      acc[item.type].items.push(item);
      return acc;
    },
    {} as Record<
      string,
      {
        items: TransferListItem[];
        icon: IconWithColor;
      }
    >
  );
}
